import { useEffect, useRef, useState } from "react";
import GreySearch from "@assets/grey_search.svg";
import WhiteSearch from "@assets/white_search.svg";
import styles from "./style.module.css";
import { useRouter } from "next/router";
import { useJobSearch } from "@src/state/jobSearch";

import Loader from "semantic-ui-react/dist/commonjs/elements/Loader";
import "semantic-ui-css/components/loader.min.css";
import Link from "next/link";

type SearchInputProps = {
  active?: boolean;
  value?: string;
  canSearch?: boolean;
  searchUrl: string;
  height: number;
  onUpdate?: Function;
  loading?: boolean;
  updateAfterClick?: boolean;
  handleAttemptSearch?: Function;
};

export default function SearchInput({
  canSearch,
  home,
  value,
  searchUrl,
  height,
  updateAfterClick,
  onUpdate,
  loading,
  handleAttemptSearch,
}: SearchInputProps) {
  const { state, dispatch } = useJobSearch();
  const [searchTerm, setSearchTerm] = useState(state?.searchTerm ?? "");
  const [error, setError] = useState(false);

  let btn = useRef(null);

  useEffect(() => {
    setSearchTerm(state?.searchTerm);
  }, [state?.searchTerm]);

  const handleInput = (e) => {
    const val = e.target.value;
    setError(false);
    setSearchTerm(val);
    if (onUpdate) {
      onUpdate(val);
    }
  };

  const handleSearchClick = () => {
    if (!searchTerm) {
      setError(true);
    }
    if (handleAttemptSearch) {
      handleAttemptSearch();
    }
  };

  const handleKeyPress = (e) => {
    if (e.charCode === 13) {
      if (!searchTerm) {
        setError(true);
      }
      if (handleAttemptSearch) {
        handleAttemptSearch();
      }
      if (btn.current) {
        btn.current.click();
      }
    }
  };

  let containerStyle = null;

  if (height) {
    containerStyle = {
      height: `${height}px`,
    };
  }

  const SearchButton = () => {
    const [loader, setLoader] = useState(false);

    if (loading || loader) {
      return <Loader active inline size="small" className={styles.loader} />;
    }
    if (canSearch) {
      return (
        <WhiteSearch
          style={{ marginRight: "2px" }}
          onClick={() => setLoader(true)}
        />
      );
    } else {
      return <GreySearch style={{ marginRight: "2px" }} />;
    }
  };

  const searchHref = canSearch ? searchUrl : null;
  console.log('search input searchHref: ', searchHref)

  const SearchWrap = ({ children }) => {
    let updateSearch = null;

    if (updateAfterClick) {
      console.log('updateAfter click (searchTerm): ', searchTerm)
      updateSearch = (e) => {
        e.stopPropagation()
        e.preventDefault()
        dispatch({ type: "updateSearch", payload: searchTerm })
      };
    }

    if (home || canSearch) {
      return (
        <div onClick={updateSearch}>
          <Link href={canSearch ? searchHref : "#"} passHref>
            {children}
          </Link>
        </div>
      );
    }
    return children;
  };

  let placeholderText;
  let inputClasses;

  if (error) {
    placeholderText = "Enter job title, industry or company*";
    inputClasses = `${styles.inputFieldSearch} ${styles.invalidInput}`;
  } else {
    placeholderText = "Enter job title, industry or company";
    inputClasses = styles.inputFieldSearch;
  }

  return (
    <div
      className={`${styles.searchField} ${loading ? styles.disabled : ""}`}
      style={containerStyle}
    >
      <input
        className={inputClasses}
        type="text"
        placeholder={placeholderText}
        value={searchTerm}
        onChange={handleInput}
        onKeyPress={handleKeyPress}
        disabled={loading}
      />
      <SearchWrap>
        <div
          className={`${styles.searchButton} ${
            canSearch ? styles.activeButton : styles.whiteButton
          }`}
          tabIndex={loading ? -1 : 0}
          ref={btn}
          onClick={handleSearchClick}
        >
          <SearchButton />
        </div>
      </SearchWrap>
    </div>
  );
}
